import { CompleteTasks as DefaultBulkCompleteTasksButton } from 'customer-data-bulk-actions/components/buttons/tasks/CompleteTasks';
import { DefaultBulkActionsCompleteTasksModalOnSuccess } from 'customer-data-bulk-actions/components/buttons/tasks/CompleteTasks';
import { COMPLETED } from 'customer-data-objects/engagement/EngagementStatusTypes';
import { STATUS } from 'customer-data-objects/task/TaskPropertyNames';
import { useCallback } from 'react';
import { TASK_INTERACTION_TYPES } from '../../constants/table';
import { useDispatch } from '../../context/Redux';
import { useTableContext } from '../../context/TableContext';
import { useTemporarilyExcludeIds } from '../../hooks/useTemporarilyExcludeIds';
import { logBulkActionUpdate, mergeTaskPropertyUpdates } from '../../redux/actions/tasksCRUD';
import { jsx as _jsx } from "react/jsx-runtime";
const COMPLETE_TASK_PROPERTY_UPDATE = [{
  name: STATUS,
  value: COMPLETED
}];
function BulkCompleteTasks({
  allSelected,
  clearSelection,
  selection
}) {
  const dispatch = useDispatch();
  const {
    onDelayedRefreshSearch
  } = useTableContext();
  const temporarilyExcludeTaskIds = useTemporarilyExcludeIds();
  const onSuccess = useCallback(({
    count
  }) => {
    DefaultBulkActionsCompleteTasksModalOnSuccess({
      count
    });
    if (!allSelected) {
      temporarilyExcludeTaskIds(selection, TASK_INTERACTION_TYPES.COMPLETE_TASKS);
    }
    dispatch(mergeTaskPropertyUpdates({
      taskIds: selection,
      propertyUpdates: COMPLETE_TASK_PROPERTY_UPDATE
    }));
    onDelayedRefreshSearch();
    clearSelection();
  }, [allSelected, dispatch, selection, onDelayedRefreshSearch, clearSelection, temporarilyExcludeTaskIds]);
  return /*#__PURE__*/_jsx(DefaultBulkCompleteTasksButton, {
    buttonProps: {
      onSuccess,
      logFunction: logBulkActionUpdate
    }
  });
}
export default BulkCompleteTasks;